import { Pipe, PipeTransform } from '@angular/core';
import { GenderType, Individual } from '@models/profile/model';

@Pipe({ name: 'individualGender' })
export class IndividualGenderPipe implements PipeTransform {
  public transform(individual: Individual): string {
    if (individual && individual.gender) {
      if (individual.gender === GenderType.OptionNotListed) {
        return individual.specifiedGender;
      } else {
        return individual.gender;
      }
    }
    return '';
  }
}
